import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';


const DEFAULT_DOMAIN = '';

export interface HygieneLocationFilters {
  schooolOrCollege?: string;
  boardingType?: string;
}
@Injectable({
  providedIn: 'root'
})
export class HygieneStaftReportService {

   private readonly API_ORIGIN = String((environment as any).masterDomain || DEFAULT_DOMAIN).trim().replace(/\/+$/, '');
   private readonly userRolesUrl = `${this.API_ORIGIN}/employee/api/jwtV2/common/userRoles`;
  private readonly payrollStorageKeys = ['userId'] as const;
  private readonly statesUrl = `${this.API_ORIGIN}/apiV2/hygiene/allowedStates`;
  private readonly citiesUrl = `${this.API_ORIGIN}/apiV2/hygiene/allowedStateCities`;
  private readonly empCitiesUrl = `${this.API_ORIGIN}/apiV2/hygiene/empCities`;
  private readonly campusesUrl = `${this.API_ORIGIN}/apiV2/hygiene/allowedEmpCampuses`;
  private readonly buildingsUrl = `${this.API_ORIGIN}/apiV2/hygiene/allowedCmpBuilding`;
  private readonly buildingBlocksUrl = `${this.API_ORIGIN}/apiV2/hygiene/buildingBlocks`;
  private readonly staffReportUrl = `${this.API_ORIGIN}/apiV2/hygiene/staffReport`;
   private readonly staffReportPagedUrl = `${this.API_ORIGIN}/apiV2/hygiene/staffReportByPagenation`;
  private readonly staffAttendanceUrl = `${this.API_ORIGIN}/apiV2/hygiene/staffAttendance`;
  private readonly activityReportUrl = `${this.API_ORIGIN}/apiV2/hygiene/activityReport`;
  private readonly staffReportDetailUrl = `${this.API_ORIGIN}/apiV2/hygiene/staffReportDetail`;
  private readonly buildingListUrl = `${this.API_ORIGIN}/apiV2/buildings/list`;
  private readonly buildingImageListBase = `${this.API_ORIGIN}/apiV2/buildings`;


    private cachedRoles$: Observable<unknown> | null = null;
  private cachedRolesPayrollId: string | null = null;
  

  private get headers(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': this.authHeaderValue,
      'Content-Type': 'application/json'
    });
  }

 
  private readonly tokenStorageKeys = ['updated', 'jwtToken', 'token', 'authToken', 'accessToken'] as const;

  private get authHeaderValue(): string {
    let raw: string | null = null;
    for (const key of this.tokenStorageKeys) {
      raw = sessionStorage.getItem(key) || localStorage.getItem(key);
      if (raw && raw.trim()) break;
    }
    const trimmed = (raw || '').trim();
    if (trimmed) return trimmed;
    return '';
  }

  constructor(private http: HttpClient) {}
   getStoredPayrollId(): string | null {
    for (const key of this.payrollStorageKeys) {
      const v = localStorage.getItem(key) || sessionStorage.getItem(key);
      if (v && String(v).trim()) return String(v).trim();
    }
    return null;
  }
    getUserRoles(payrollId?: string): Observable<unknown> {
    const pid = (payrollId ?? this.getStoredPayrollId() ?? '').trim();
    if (!pid) {
      return of(null);
    }
    const qs = new URLSearchParams();
    qs.set('payrollId', pid);
    return this.http.get(`${this.userRolesUrl}?${qs.toString()}`, { headers: this.headers });
  }
   getUserRolesCached(payrollId?: string): Observable<unknown> {
    const pid = (payrollId ?? this.getStoredPayrollId() ?? '').trim() || null;
    if (!pid) return of(null);
    if (this.cachedRoles$ && this.cachedRolesPayrollId === pid) return this.cachedRoles$;
    this.cachedRolesPayrollId = pid;
    this.cachedRoles$ = this.getUserRoles(pid).pipe(shareReplay(1));
    return this.cachedRoles$;
  }

  /** Alias for {@link getUserRoles} (includes `userAppForms` for sidebar menus). */
  getRole(payrollId?: string): Observable<unknown> {
    return this.getUserRoles(payrollId);
  }

  /**
   * Flattens common `userRoles` response shapes to display strings (roleName, name, code, or string entries).
   */
  parseUserRolesPayload(res: unknown): string[] {
    if (res == null) return [];
    if (Array.isArray(res)) {
      return (res as unknown[])
        .map((x) =>
          typeof x === 'string' ? x : (x as any)?.roleName ?? (x as any)?.name ?? (x as any)?.code ?? String(x)
        )
        .map((s) => String(s).trim())
        .filter((s) => s.length > 0);
    }
    const o = res as Record<string, unknown>;
    const inner = o?.['data'] ?? o?.['roles'] ?? o?.['userRoles'] ?? o?.['roleList'] ?? o?.['result'];
    if (Array.isArray(inner)) {
      return this.parseUserRolesPayload(inner);
    }
    return [];
  }
 private collegeTypeQueryValue(schoolOrCollege: string): string {
  const u = (schoolOrCollege || '').toUpperCase();
  if (u === 'SCHOOL') return 'SCHOOL';
  if (u === 'COLLEGE') return 'COLLEGE';
  return schoolOrCollege;
}
  private campusTypeQueryValue(boardingType: string): string {
    const u = (boardingType || '').toUpperCase();
    if (u === 'DAY_SCHOLAR') return 'DAYSCHOLAR';
    if (u === 'RESIDENTIAL') return 'RESIDENTIAL';
    return boardingType;
  }

  private appendLocationFilters(qs: URLSearchParams, filters?: HygieneLocationFilters): void {
    if (!filters) return;
    if (filters.schooolOrCollege) {
      qs.set('collegeType', this.collegeTypeQueryValue(filters.schooolOrCollege));
    }
    if (filters.boardingType) {
      qs.set('campusType', this.campusTypeQueryValue(filters.boardingType));
    }
  }

  // ─── Dropdown APIs ─────────────────────────────────────────────────────────
 getrole(){

 }
  getStates(filters?: HygieneLocationFilters): Observable<unknown> {
    const qs = new URLSearchParams();
    this.appendLocationFilters(qs, filters);
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return this.http.get(`${this.statesUrl}${suffix}`, { headers: this.headers });
  }

  getEmpCities(filters?: HygieneLocationFilters): Observable<unknown> {
    const qs = new URLSearchParams();
    this.appendLocationFilters(qs, filters);
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return this.http.get(`${this.empCitiesUrl}${suffix}`, { headers: this.headers });
  }

  getCities(stateId: string | number, filters?: HygieneLocationFilters): Observable<unknown> {
    const qs = new URLSearchParams();
    qs.set('stateId', String(stateId));
    this.appendLocationFilters(qs, filters);
    return this.http.get(`${this.citiesUrl}?${qs.toString()}`, { headers: this.headers });
  }

  getCampuses(cityId: string | number, filters?: HygieneLocationFilters): Observable<unknown> {
    const qs = new URLSearchParams();
    qs.set('cityId', String(cityId));
    this.appendLocationFilters(qs, filters);
    return this.http.get(`${this.campusesUrl}?${qs.toString()}`, { headers: this.headers });
  }

  getBuildings(campusId: string | number, filters?: HygieneLocationFilters): Observable<unknown> {
    const qs = new URLSearchParams();
    qs.set('campusId', String(campusId));
    this.appendLocationFilters(qs, filters);
    return this.http.get(`${this.buildingsUrl}?${qs.toString()}`, { headers: this.headers });
  }

  getBuildingBlocks(buildingId: string | number, filters?: HygieneLocationFilters): Observable<unknown> {
    const qs = new URLSearchParams();
    qs.set('buildingId', String(buildingId));
    this.appendLocationFilters(qs, filters);
    return this.http.get(`${this.buildingBlocksUrl}?${qs.toString()}`, { headers: this.headers });
  }

  getBuildingListFilter(payload: { stateId?: number | null; cityId?: number | null; campusId?: number | null; buildingId?: number | null; schooolOrCollege?: string; boardingType?: string }): Observable<unknown> {
    const qs = new URLSearchParams();
    if (payload.stateId != null) qs.set('stateId', String(payload.stateId));
    if (payload.cityId != null) qs.set('cityId', String(payload.cityId));
    if (payload.campusId != null) qs.set('campusId', String(payload.campusId));
    if (payload.buildingId != null) qs.set('buildingId', String(payload.buildingId));
    this.appendLocationFilters(qs, {
      schooolOrCollege: payload.schooolOrCollege,
      boardingType: payload.boardingType
    });
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return this.http.get(this.buildingListUrl + suffix, { headers: this.headers });
  }

  getBuildingImageList(buildingId: number, filters?: HygieneLocationFilters): Observable<{ buildingImageUrlList?: string[] }> {
    const qs = new URLSearchParams();
    this.appendLocationFilters(qs, filters);
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return this.http.get<{ buildingImageUrlList?: string[] }>(
      `${this.buildingImageListBase}/${buildingId}/images${suffix}`,
      { headers: this.headers }
    );
  }

  // ─── Report API ─────────────────────────────────────────────────────────────

  buildStaffReportQueryString(params?: {
    stateId?: string;
    cityId?: string;
    campusId?: string;
    buildingId?: string;
    blockId?: string;
    name?: string;
    schooolOrCollege?: string;
    boardingType?: string;
    filterType?: string;
    startDate?: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
  }): string {
    if (!params) return '';
    const apiParams: Record<string, string> = {};
    if (params['stateId']) apiParams['stateId'] = params['stateId'];
    if (params['cityId']) apiParams['cityId'] = params['cityId'];
    if (params['campusId']) apiParams['campusId'] = params['campusId'];
    if (params['buildingId']) apiParams['buildingId'] = params['buildingId'];
    if (params['blockId']) apiParams['blockId'] = params['blockId'];
    if (params['name']) apiParams['name'] = params['name'];
    if (params['schooolOrCollege']) {
      apiParams['collegeType'] = this.collegeTypeQueryValue(params['schooolOrCollege']);
    }
    if (params['boardingType']) {
      apiParams['campusType'] = this.campusTypeQueryValue(params['boardingType']);
    }
    if (params['filterType']) apiParams['filterType'] = params['filterType'];
    if (params['startDate'] != null && params['endDate'] != null) {
      apiParams['filterType'] = 'CUSTOM';
      apiParams['fromDate'] = this.toDDMMYYYY(params['startDate']);
      apiParams['toDate'] = this.toDDMMYYYY(params['endDate']);
    }
    if (params.page != null && Number.isFinite(Number(params.page))) {
      const uiPage = Math.floor(Number(params.page));
      if (uiPage >= 1) {
        apiParams['page'] = String(Math.max(0, uiPage - 1));
      }
    }
    if (params.pageSize != null && Number.isFinite(Number(params.pageSize)) && Number(params.pageSize) > 0) {
      apiParams['size'] = String(Math.floor(Number(params.pageSize)));
    }
    return Object.keys(apiParams).length ? '?' + new URLSearchParams(apiParams).toString() : '';
  }

  getStaffReportCheck(params?: Parameters<HygieneStaftReportService['buildStaffReportQueryString']>[0]): {
    method: 'GET';
    url: string;
    hygieneApiBase: string;
    authSource: string;
    authorizationLength: number;
  } {
    const qs = this.buildStaffReportQueryString(params);
    let authSource = 'embedded-fallback';
    for (const key of this.tokenStorageKeys) {
      const raw = sessionStorage.getItem(key) || localStorage.getItem(key);
      if (raw && raw.trim()) {
        authSource = `storage:${key}`;
        break;
      }
    }
    return {
      method: 'GET',
      url: `${this.staffReportUrl}${qs}`,
      hygieneApiBase: `${this.API_ORIGIN}/apiV2/hygiene`,
      authSource,
      authorizationLength: this.authHeaderValue.length
    };
  }


  getStaffReport(params?: { stateId?: string; cityId?: string; campusId?: string; buildingId?: string; blockId?: string; name?: string; schooolOrCollege?: string; boardingType?: string; filterType?: string; startDate?: string; endDate?: string }): Observable<HygieneStaffReport> {
    const qs = this.buildStaffReportQueryString(params);
    return this.http.get<HygieneStaffReport>(`${this.staffReportUrl}${qs}`, { headers: this.headers });
  }

  getStaffReportByPagenation(params?: {stateId?: string; cityId?: string; campusId?: string; buildingId?: string; blockId?: string; name?: string; schooolOrCollege?: string; boardingType?: string; filterType?: string; startDate?: string; endDate?: string;
    page?: number;
    pageSize?: number;
  }): Observable<HygieneStaffReport> {
    const qs = this.buildStaffReportQueryString(params as any);
    return this.http.get<HygieneStaffReport>(`${this.staffReportPagedUrl}${qs}`, { headers: this.headers });
  }


  getStaffAttendance(params: {
    year: number;
    /** 1–12 */
    month: number;
    stateId?: string;
    cityId?: string;
    campusId?: string;
    buildingId?: string;
    /** e.g. Maintenance — sent as departmentName */
    departmentName?: string;
    schooolOrCollege?: string;
    boardingType?: string;
  }): Observable<HygieneStaffAttendanceCampus[]> {
    const qs = new URLSearchParams();
    if (params.stateId) qs.set('stateId', params.stateId);
    if (params.cityId) qs.set('cityId', params.cityId);
    if (params.campusId) qs.set('campusId', params.campusId);
    if (params.buildingId) qs.set('buildingId', params.buildingId);
    if (params.departmentName) qs.set('departmentName', params.departmentName);
    qs.set('year', String(params.year));
    qs.set('month', String(params.month));
    if (params.boardingType) {
      qs.set('campusType', this.campusTypeQueryValue(params.boardingType));
    }
    if (params.schooolOrCollege) {
      qs.set('collegeType', this.collegeTypeQueryValue(params.schooolOrCollege));
    }
    return this.http.get<HygieneStaffAttendanceCampus[]>(`${this.staffAttendanceUrl}?${qs.toString()}`, { headers: this.headers });
  }

  getStaffAttendanceImages(
    /** YYYY-MM-DD (e.g. 2026-03-25); DD-MM-YYYY is normalized to ISO */
    hygieneDate: string,
    buildingId?: number | string | null
  ): Observable<StaffAttendanceImage[]> {
    const qs = new URLSearchParams();
    qs.set('hygieneDate', this.hygieneDateParamIso(hygieneDate));
    if (buildingId != null && String(buildingId).trim() !== '') {
      qs.set('buildingId', String(buildingId));
    }
    const url = `${this.API_ORIGIN}/employee/api/jwtV2/hygiene/getStaffAttendanceImages?${qs.toString()}`;
    return this.http.get<StaffAttendanceImage[]>(url, { headers: this.headers });
  }
  private hygieneDateParamIso(value: string): string {
    if (!value) return value;
    const s = value.toString().trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
      return s.slice(0, 10);
    }
    if (/^\d{2}-\d{2}-\d{4}$/.test(s)) {
      const [d, m, y] = s.split('-');
      return `${y}-${m}-${d}`;
    }
    return s;
  }

  /** Convert YYYY-MM-DD to DD-MM-YYYY for API */
  private toDDMMYYYY(iso: string): string {
    if (!iso) return iso;
    const s = iso.toString().trim();
    // If already DD-MM-YYYY, keep as-is
    if (/^\d{2}-\d{2}-\d{4}$/.test(s)) return s;
    // Convert YYYY-MM-DD → DD-MM-YYYY
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
      const [y, m, d] = s.slice(0, 10).split('-');
      return [d, m, y].join('-');
    }
    return s;
  }

  getStaffReportDetail(imageRefId: number, filters?: HygieneLocationFilters): Observable<HygieneStaffDetailResponse> {
    const qs = new URLSearchParams();
    qs.set('imageRefId', String(imageRefId));
    this.appendLocationFilters(qs, filters);
    return this.http.get<HygieneStaffDetailResponse>(`${this.staffReportDetailUrl}?${qs.toString()}`, { headers: this.headers });
  }
 getActivityReport(params?: { stateId?: string; cityId?: string; campusId?: string; buildingId?: string;blockId?: string; schooolOrCollege?: string; boardingType?: string;filterType?: string;startDate?: string;endDate?: string;
        page?: number;
    pageSize?: number;
  }): Observable<HygieneActivityReport> {
    const apiParams: Record<string, string> = {};
    if (!params) {
      return this.http.get<HygieneActivityReport>(this.activityReportUrl, { headers: this.headers });
    }
    if (params['stateId']) apiParams['stateId'] = params['stateId'];
    if (params['cityId']) apiParams['cityId'] = params['cityId'];
    if (params['campusId']) apiParams['campusId'] = params['campusId'];
    if (params['buildingId']) apiParams['buildingId'] = params['buildingId'];
    if (params['blockId']) apiParams['blockId'] = params['blockId'];
    if (params['schooolOrCollege']) {
      apiParams['collegeType'] = this.collegeTypeQueryValue(params['schooolOrCollege']);
    }
    if (params['boardingType']) {
      apiParams['campusType'] = this.campusTypeQueryValue(params['boardingType']);
    }
    if (params['filterType']) apiParams['filterType'] = params['filterType'];
    if (params['startDate'] != null && params['endDate'] != null) {
      apiParams['filterType'] = 'CUSTOM';
      apiParams['fromDate'] = this.toDDMMYYYY(params['startDate']);
      apiParams['toDate'] = this.toDDMMYYYY(params['endDate']);
    }
    if (params.page != null && Number.isFinite(Number(params.page))) {
      const uiPage = Math.floor(Number(params.page));
      if (uiPage >= 1) {
        apiParams['page'] = String(Math.max(0, uiPage - 1));
      }
    }
    if (params.pageSize != null && Number.isFinite(Number(params.pageSize)) && Number(params.pageSize) > 0) {
      apiParams['size'] = String(Math.floor(Number(params.pageSize)));
    }
    const qs = Object.keys(apiParams).length ? '?' + new URLSearchParams(apiParams).toString() : '';
    return this.http.get<HygieneActivityReport>(`${this.activityReportUrl}${qs}`, { headers: this.headers });
  }
}

export interface HygieneActivityImage {
  hygieneId: number;
  activityId: number;
  activityName: string;
  fileName?: string;
  imagePath?: string;
  capturedTime?: string;
  slot?: string;
  latitude?: number | string;
  longitude?: number | string;
}

export interface HygieneActivityRoom {
  roomNo?: string | number;
  roomDisplayName?: string;
  images: HygieneActivityImage[];
}

export interface HygieneActivityFloor {
  floorName: string;
  rooms: HygieneActivityRoom[];
}

export interface HygieneActivityReport {
  todayPhotoCount: number;
  yesterdayPhotoCount: number;
  last7DaysPhotoCount: number;
  thisMonthPhotoCount: number;
  isBuilding?: boolean;
  floors: HygieneActivityFloor[];
  totalRecords?: number;
  totalPages?: number;
  currentPage?: number;
}

export interface HygieneStaffAttendanceDay {
  date: string;
  att: string;
}

export interface StaffAttendanceImage {
  url?: string;
  uplodedTime?: string;
  uploadedTime?: string;
}

export interface HygieneStaffAttendanceCampus {
  buildingName: string;
  buildingId: null;
  campusId?: number;
  campusName?: string;
  stateId?: number;
  stateName?: string;
  cityId?: number;
  cityName?: string;
  attendance?: HygieneStaffAttendanceDay[];
}

export interface HygieneStaffDetailItem {
  staffName: string;
  aadharNo: number | string;
}

export interface HygienePicture {
  departmentName: string;
  employeeCount: number;
  fileName: string;
  hygieneDate: string;
  imageRefId: number;
  campusName?: string;
  buildingName?: string;
  activityName?: string;
  employeeName?: string;
  designation?: string;
  mobileNo?: string;
  staffDetails?: HygieneStaffDetailItem[];
  latitude?: string | number;
  longitude?: string | number;
  hygieneId?: number;
}

export interface HygieneStaffReport {
  todayPhotoCount: number;
  yesterdayPhotoCount: number;
  last7DaysPhotoCount: number;
  thisMonthPhotoCount: number;
  pictures: HygienePicture[];
  totalCount?: number;
  totalPages?: number;
  currentPage?: number;
}

export interface HygieneStaffDetailResponse {
  data?: { staffDetails?: HygieneStaffDetailItem[] };
  staffDetails?: HygieneStaffDetailItem[];
}


